import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=eb12f976&scoped=true&"
import script from "./ProjectsView.vue?vue&type=script&lang=ts&"
export * from "./ProjectsView.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsView.vue?vue&type=style&index=0&id=eb12f976&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb12f976",
  null
  
)

export default component.exports